var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import clsx from 'clsx';
import { GetCommonSettings } from '@themes/common/data';
import { LoadingIcon } from '@themes/common/components';
import { GetLocationDistance, RoundOff } from '@themes/common/utils';
import { GetDisplayUnit } from '@themes/common/display-units';
import ImportAxios from '@themes/common/axios';
import { StringReplaceCurlyBraces } from '@commons/replaceCurly';
import { format, parseISO } from 'date-fns';
import { enUS, sv } from 'date-fns/locale';
import { FormatMoney } from '@components/Shared/Utils/price';
import useProductPage from '@themes/product/useProductPage';
import { debounce } from 'lodash';
import { IS_NORWAY } from '@commons/appType';
const ShopLocations = (_a = globalThis.ShopLocations) !== null && _a !== void 0 ? _a : [];
const WarehouseCodes = ShopLocations.map((f) => f.code);
export const FilterMainLocation = (location) => {
    return (!!location.warehouse &&
        (WarehouseCodes !== null && WarehouseCodes !== void 0 ? WarehouseCodes : ['H_MAR', 'H_SKO', 'H_JAG', 'H_MAL', 'GBG', 'H_NOR']).includes(location.warehouse.code) &&
        !!location.locationAddress);
};
export const FilterValidWarehouse = (location, product) => {
    return (!location.tracksInventory ||
        (location.tracksInventory &&
            location.available > 0 &&
            (location.warehouse.isOnlineStock || location.stockManaged == 'Lagerstyrd' || product.tags.includes('utgående'))));
};
const FormatIncommingDate = (incommingDate, out_of_stock = false) => {
    const { translations } = GetCommonSettings();
    const date = incommingDate
        ? format(typeof incommingDate === 'string' ? parseISO(incommingDate) : incommingDate, 'iii, MMM d', {
            locale: (Shopify === null || Shopify === void 0 ? void 0 : Shopify.locale) === 'sv' ? sv : enUS,
        }).replace('.', '')
        : null;
    return date
        ? StringReplaceCurlyBraces(out_of_stock ? translations.product.status.out_of_stock_incoming : translations.product.status.incoming, { date })
        : null;
};
const StockStatus = (quantity = 0, product, locations, selectedLocation) => {
    locations = selectedLocation ? [selectedLocation] : locations;
    const totalQuantity = locations.reduce((r, c) => r + c.available, 0);
    const totalHQuantity = locations.filter(FilterMainLocation).reduce((r, c) => r + c.available, 0);
    const tracked = locations.some((f) => f.tracksInventory);
    const onlineStock = locations.some((f) => f.warehouse.isOnlineStock);
    const madeToOrder = locations.some((f) => f.stockManaged == 'Orderstyrd') && !onlineStock;
    const outgoing = product.tags.includes('utgående') && !onlineStock;
    const hasIncomming = locations.some((f) => f.incommingDate);
    if (!tracked) {
        return 'in_stock';
    }
    if (hasIncomming) {
        return 'arrival_date';
    }
    if (totalQuantity > 0) {
        if (totalQuantity < quantity && !selectedLocation) {
            return outgoing ? 'sold_out' : 'order_item';
        }
        return totalHQuantity <= 0 ? 'order_item' : 'in_stock';
    }
    if (madeToOrder) {
        return outgoing ? 'web_stock_sold_out' : 'order_item';
    }
    return 'sold_out';
};
const DisplayTranslation = (displayStatus) => {
    const { translations } = GetCommonSettings();
    switch (displayStatus) {
        case 'in_stock':
            return translations.product.status.in_stock;
        case 'sold_out':
            return translations.product.status.sold_out;
        case 'order_item':
            return translations.delivery.order_item;
        case 'web_stock_sold_out':
            return translations.product.status.web_stock_sold_out;
        case 'arrival_date':
            return translations.product.status.in_stock;
        default:
            return translations.product.status.sold_out;
    }
};
const DisplayColor = (displayStatus) => {
    switch (displayStatus) {
        case 'in_stock':
            return 'default';
        case 'sold_out':
            return 'sold-out';
        case 'order_item':
            return 'order-item';
        case 'web_stock_sold_out':
            return 'sold-out';
        case 'arrival_date':
            return 'default';
        default:
            return 'default';
    }
};
const DeliveryTime = ({ product, settings, hideOnlineStock, icons, element }) => {
    var _a;
    const { max_delivery_time, min_delivery_time } = settings;
    const { variant_id, title, metafields, unit_factor, unit } = product;
    const lead_time = metafields['SB-P']['LeadTime'] ? Number(metafields['SB-P']['LeadTime']) : 0;
    const [loading, setLoading] = useState(true);
    const [locations, setLocations] = useState([]);
    const [additionalRange, setAdditionalRange] = useState(0);
    const [qty, setQty] = useState(1);
    const [showLocation, setShowLocation] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(null);
    const { translations } = GetCommonSettings();
    const hLocations = useMemo(() => locations.filter((f) => FilterMainLocation(f)), [locations]);
    const totalQty = useMemo(() => locations.reduce((r, c) => r + c.available, 0), [locations]);
    const totalHQty = useMemo(() => hLocations.reduce((r, c) => r + c.available, 0), [hLocations]);
    const totalSafetyStock = useMemo(() => hLocations.reduce((r, c) => { var _a; return r + ((_a = c.safetyStock) !== null && _a !== void 0 ? _a : 0); }, 0), [hLocations]);
    const maxSafteyStock = useMemo(() => (totalSafetyStock > 0 ? Math.max(...hLocations.map((f) => { var _a; return (_a = f.safetyStock) !== null && _a !== void 0 ? _a : 0; })) : 0), [hLocations, totalSafetyStock]);
    const withoutStockmanagement = locations.every((f) => f.warehouse.isOnlineStock);
    const incommingDate = useMemo(() => {
        var _a, _b;
        const incommingDateString = (_b = (_a = locations.find((f) => f.incommingDate)) === null || _a === void 0 ? void 0 : _a.incommingDate) !== null && _b !== void 0 ? _b : null;
        return incommingDateString ? parseISO(incommingDateString.toString()) : null;
    }, [locations]);
    const arrivalDate = useMemo(() => (incommingDate && (totalHQty < qty || totalHQty < maxSafteyStock) ? FormatIncommingDate(incommingDate, totalHQty <= 0) : null), [incommingDate, maxSafteyStock, qty, totalHQty]);
    const stockStatus = useMemo(() => StockStatus(qty, product, locations), [qty, product, locations]);
    useEffect(() => {
        const fetchWarehouses = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                globalThis.common_deliveries = (_a = globalThis.common_deliveries) !== null && _a !== void 0 ? _a : {};
                let warehouseLocations = globalThis.common_deliveries[variant_id];
                if (!(warehouseLocations === null || warehouseLocations === void 0 ? void 0 : warehouseLocations.length)) {
                    const axios = yield ImportAxios();
                    const result = yield axios.get(`${process.env.HOST}/api/product/deliverytime`, {
                        params: {
                            ids: variant_id,
                            marketHandle: globalThis.Localization.market.handle,
                        },
                    });
                    warehouseLocations = Object.values(result.data)[0];
                    globalThis.common_deliveries = Object.assign(Object.assign({}, globalThis.common_deliveries), result.data);
                }
                if (warehouseLocations.length) {
                    setLocations(warehouseLocations);
                }
                jQuery('.sb-product-form').removeClass('hidden');
            }
            catch (e) {
                console.error(e);
            }
            setLoading(false);
        });
        const debounceFetch = debounce(fetchWarehouses, 100);
        debounceFetch();
        return () => {
            debounceFetch.cancel();
        };
    }, [variant_id, product, withoutStockmanagement]);
    useEffect(() => {
        if (totalHQty < qty) {
            if (incommingDate) {
                const today = new Date();
                const diffTime = Math.abs(incommingDate.getTime() - today.getTime());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                setAdditionalRange(diffDays);
            }
            else {
                setAdditionalRange(lead_time);
            }
        }
        else {
            setAdditionalRange(0);
        }
    }, [totalHQty, lead_time, qty, incommingDate]);
    useEffect(() => {
        jQuery('[id="product[properties][delivery_min]"]').val(min_delivery_time);
        jQuery('[id="product[properties][delivery_max]"]').val(max_delivery_time);
    }, [max_delivery_time, min_delivery_time]);
    useEffect(() => {
        const onChange = (e) => {
            setQty(parseInt(jQuery(e.currentTarget).val()));
        };
        jQuery('#product-quantity-input').on('change', onChange);
        return () => {
            jQuery('#product-quantity-input').off('change', onChange);
        };
    }, []);
    useEffect(() => {
        if (showLocation) {
            jQuery('html').addClass('scroll-locked');
        }
        else {
            jQuery('html').removeClass('scroll-locked');
        }
    }, [showLocation]);
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => setCurrentLocation(position));
        }
    }, []);
    useEffect(() => {
        const tracked = locations.some((f) => f.tracksInventory);
        const form = jQuery('form[data-sb-product-form]');
        const actionButton = jQuery('button[data-product-atc]');
        const ouOfStock = totalQty <= 0 && tracked;
        const preventDefault = (e) => {
            e.preventDefault();
        };
        if (ouOfStock) {
            actionButton.addClass('disabled');
            actionButton.attr('disabled', 'disabled');
            actionButton.text(translations.product.sold_out);
            form.on('submit', preventDefault);
            form.addClass('disabled');
        }
        else {
            actionButton.removeClass('disabled');
            actionButton.removeAttr('disabled');
            actionButton.text(translations.product.add_to_cart);
            form.off('submit', preventDefault);
            form.removeClass('disabled');
        }
    }, [locations, totalQty, translations.product.add_to_cart, translations.product.sold_out]);
    const sorted_locations = locations
        .filter((f) => { var _a, _b; return !((_a = f.locationName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('online')) && !!((_b = f === null || f === void 0 ? void 0 : f.warehouse) === null || _b === void 0 ? void 0 : _b.city); })
        .map((location) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, location), { distance: (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.coords) && ((_a = location.locationAddress) === null || _a === void 0 ? void 0 : _a.latitude) && ((_b = location.locationAddress) === null || _b === void 0 ? void 0 : _b.longitude)
                ? GetLocationDistance(currentLocation.coords.latitude, currentLocation.coords.longitude, location.locationAddress.latitude, location.locationAddress.longitude)
                : null }));
    })
        .sort((a, b) => { var _a, _b; return ((_a = a.distance) !== null && _a !== void 0 ? _a : Number.MAX_VALUE) - ((_b = b.distance) !== null && _b !== void 0 ? _b : Number.MAX_VALUE); });
    const availableLocations = sorted_locations.filter((location) => FilterValidWarehouse(location, product));
    const closestLocation = (_a = availableLocations[0]) !== null && _a !== void 0 ? _a : sorted_locations[0];
    const tracked = sorted_locations.some((f) => f.tracksInventory);
    const cities = [closestLocation, ...sorted_locations]
        .filter((f) => { var _a; return (_a = f === null || f === void 0 ? void 0 : f.warehouse) === null || _a === void 0 ? void 0 : _a.city; })
        .map((s) => { var _a; return (_a = s.warehouse) === null || _a === void 0 ? void 0 : _a.city; })
        .filter((value, index, self) => self.indexOf(value) === index);
    const displayStatus = arrivalDate ? null : DisplayTranslation(stockStatus);
    const in_stock = arrivalDate
        ? false
        : tracked
            ? totalHQty > 0
                ? additionalRange > 0
                    ? !product.tags.includes('utgående') && !withoutStockmanagement
                    : true
                : hLocations.filter((f) => f.stockManaged == 'Orderstyrd').length > 0 && !withoutStockmanagement
            : true;
    const formatDisplay = (data) => FormatMoney(data, '{{amount_no_decimals}}');
    let closestComponent = null;
    if (closestLocation) {
        const LocationStatus = closestLocation.tracksInventory && closestLocation.available > 0 ? (_jsxs(_Fragment, { children: [formatDisplay((closestLocation.available / unit_factor) * 100).replace(',', ' '), " ", GetDisplayUnit(unit)] })) : (DisplayTranslation(StockStatus(qty, product, locations, closestLocation)));
        const LocationIconColor = DisplayColor(StockStatus(qty, product, locations, closestLocation));
        closestComponent = (_jsxs("div", Object.assign({ className: 'inventory_item' }, { children: [_jsxs("div", Object.assign({ className: 'title' }, { children: [_jsx("span", Object.assign({ className: clsx('material-icons', `status-color--${LocationIconColor}`) }, { children: icons[`icon-${LocationIconColor}`] })), ' ', closestLocation.locationName] })), _jsxs("div", Object.assign({ className: 'content' }, { children: [LocationStatus, closestLocation.distance && _jsxs("sup", Object.assign({ className: 'location--distance' }, { children: [RoundOff(closestLocation.distance, 1), " km"] }))] }))] })));
    }
    const limited_warehouse = hLocations.filter((f) => f.available <= 0).length == hLocations.length && !withoutStockmanagement;
    const limited = limited_warehouse && availableLocations.length > 0;
    const availableQuantity = totalHQty > 0 && tracked ? (_jsxs(_Fragment, { children: [formatDisplay((totalHQty / unit_factor) * 100).replace(',', ' '), " ", GetDisplayUnit(unit)] })) : (DisplayTranslation(stockStatus));
    const totalAvailable = tracked
        ? limited_warehouse && totalQty > 0 && availableLocations.length > 0
            ? limited
                ? translations.delivery.limited
                : translations.delivery.limited_warehouse
            : availableQuantity
        : translations.product.status.in_stock;
    const totalIconColor = tracked
        ? limited_warehouse && totalQty > 0 && availableLocations.length > 0
            ? limited
                ? 'limited'
                : 'limited-warehouse'
            : DisplayColor(stockStatus)
        : DisplayColor(stockStatus);
    const totalComponent = (_jsxs("div", Object.assign({ className: 'inventory_item' }, { children: [_jsxs("div", Object.assign({ className: 'title' }, { children: [loading ? (_jsx(LoadingIcon, {})) : (_jsx("span", Object.assign({ className: clsx('material-icons', `status-color--${totalIconColor}`) }, { children: icons[`icon-${totalIconColor}`] }))), ' ', translations.delivery.warehouse] })), !loading && (_jsxs("div", Object.assign({ className: 'content warehouse-content' }, { children: [totalAvailable, arrivalDate && _jsx("br", {}), arrivalDate] })))] })));
    const handleCloseModal = (e) => {
        e.preventDefault();
        if (e.target === e.currentTarget) {
            setShowLocation(false);
        }
    };
    const showAllIcon = loading ? _jsx(LoadingIcon, {}) : _jsx("span", Object.assign({ className: 'material-icons' }, { children: "info" }));
    const showAllComponent = (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _jsx("div", Object.assign({ className: 'inventory_item link', onClick: () => {
            if (sorted_locations.length)
                setShowLocation(true);
        } }, { children: _jsxs("div", Object.assign({ className: 'title' }, { children: [showAllIcon, " ", translations.delivery.show_all_stock] })) })));
    const locationItem = (location) => {
        var _a;
        const display = location.available > 0 && location.tracksInventory ? (_jsxs(_Fragment, { children: [formatDisplay((location.available / unit_factor) * 100).replace(',', ' '), " ", GetDisplayUnit(unit)] })) : (DisplayTranslation(StockStatus(qty, product, locations, location)));
        return (_jsx("div", Object.assign({ className: 'location-list-item' }, { children: _jsxs("div", Object.assign({ className: 'name' }, { children: [_jsxs("div", Object.assign({ className: 'title' }, { children: [_jsx("b", Object.assign({ className: 'location' }, { children: location.locationName })), _jsx("div", Object.assign({ className: 'status' }, { children: display }))] })), _jsxs("div", Object.assign({ className: 'address' }, { children: [_jsx("div", Object.assign({ className: 'city' }, { children: (_a = location.locationAddress) === null || _a === void 0 ? void 0 : _a.city })), location.distance && _jsxs("small", Object.assign({ className: 'location--distance' }, { children: [" ", RoundOff(location.distance, 1), " km"] }))] })), !!location.incommingDate && (location.available < location.safetyStock || location.available < qty) && (_jsx("div", { children: FormatIncommingDate(location.incommingDate, location.available <= 0) }))] })) }), location.id));
    };
    const ListsOfLocations = cities.map((city) => (_jsxs(React.Fragment, { children: [_jsx("h3", Object.assign({ className: 'location-list-item--title' }, { children: city !== null && city !== void 0 ? city : 'Locations' })), sorted_locations.filter((f) => f.warehouse.city === city).map(locationItem)] }, city)));
    const modalDisplay = sorted_locations.length
        ? ReactDOM.createPortal(_jsx("div", Object.assign({ className: clsx('modal-window', {
                open: showLocation,
            }), onClick: handleCloseModal, "aria-hidden": 'true' }, { children: _jsx("div", Object.assign({ className: 'modal-wrapper' }, { children: _jsxs("div", Object.assign({ className: 'modal-container' }, { children: [_jsx("a", Object.assign({ href: '#modal', title: 'Close', className: 'modal-close', onClick: () => {
                                setShowLocation(false);
                            } }, { children: _jsx("span", Object.assign({ className: 'material-icons' }, { children: "close" })) })), _jsx("div", Object.assign({ className: 'modal-title' }, { children: title })), _jsx("div", Object.assign({ className: 'modal-content' }, { children: _jsx("div", Object.assign({ id: '#location-list', className: 'location-list-wrapper' }, { children: ListsOfLocations })) }))] })) })) })), document.getElementById('sb-react-portal'))
        : null;
    const featuredWarehouse = !loading && sorted_locations.length ? closestComponent : null;
    return (_jsxs(_Fragment, { children: [modalDisplay, _jsxs("div", Object.assign({ className: 'location-wrapper' }, { children: [_jsx("div", Object.assign({ className: 'inventory' }, { children: !hideOnlineStock && (_jsxs(_Fragment, { children: [totalComponent, IS_NORWAY ? null : featuredWarehouse] })) })), _jsxs("div", Object.assign({ className: 'delivery-time' }, { children: [_jsxs("div", Object.assign({ className: 'inventory_item text-ellipsis overflow-hidden' }, { children: [_jsxs("span", Object.assign({ className: 'title' }, { children: [displayStatus ? `${displayStatus}` : '', in_stock && _jsxs("span", { children: [", ", translations.delivery.delivery_time] })] })), in_stock && (_jsxs("span", Object.assign({ className: 'content' }, { children: [min_delivery_time + additionalRange, " - ", max_delivery_time + additionalRange, " ", translations.delivery.working_days] })))] })), IS_NORWAY ? null : showAllComponent] }))] }))] }));
};
const DeliveryTimeWrapper = (props) => {
    const [{ product }] = useProductPage(0, 0, [], null, false, false);
    return (product === null || product === void 0 ? void 0 : product.variant_id) ? _jsx(DeliveryTime, Object.assign({}, props, { product: product })) : _jsx(_Fragment, {});
};
export default DeliveryTimeWrapper;
